import React from 'react';
import { Typography } from '@mui/material';
import './GradientFooter.css';

const GradientFooter = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="gradient-footer">
      <div className="footer-content">
        <Typography variant="body2" className="footer-text">
          © {currentYear} IO Health. All rights reserved.
        </Typography>
        <div className="footer-links">
          <a href="#privacy" className="footer-link">Privacy Policy</a>
          <a href="#terms" className="footer-link">Terms of Service</a>
          <a href="#contact" className="footer-link">Contact Us</a>
        </div>
      </div>
    </footer>
  );
};

export default GradientFooter;